( function () {
   
    'use strict';

    ( function ( $ ) {
        if($('.title-bg-video-overlay-content').length > 0){
        const video = document.getElementById("video-bg");
        const circlePlayButton = document.getElementById("circle-play-b");

        function togglePlay() {
            if (video.paused || video.ended) {
                video.play();
            } else {
                video.pause();
            }
        }

        circlePlayButton.addEventListener("click", togglePlay);
        video.addEventListener("playing", function () {
            circlePlayButton.style.opacity = 0;
        });
        video.addEventListener("pause", function () {
            circlePlayButton.style.opacity = 1;
        });
    }
    } )( jQuery );
} )();

